import { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "../lib/api";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setStatus("error"); return; }
    const poll = async () => {
      if (attempts.current >= 6) { setStatus("timeout"); return; }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/billing/status/${sid}`);
        if (data.payment_status === "paid") return setStatus("paid");
        if (data.status === "expired") return setStatus("error");
        setTimeout(poll, 2000);
      } catch (e) {
        setTimeout(poll, 2000);
      }
    };
    poll();
  }, [params]);

  const map = {
    checking: { icon: <Loader2 className="w-14 h-14 text-brand animate-spin" />, title: "Confirming payment", sub: "Hang tight, this only takes a moment..." },
    paid: { icon: <CheckCircle2 className="w-14 h-14 text-success" />, title: "Subscription active!", sub: "Your membership is live. Time to train." },
    timeout: { icon: <Loader2 className="w-14 h-14 text-warning" />, title: "Still processing", sub: "We'll email your receipt once confirmed." },
    error: { icon: <XCircle className="w-14 h-14 text-brand" />, title: "Payment not completed", sub: "No charge was made. You can try again anytime." },
  };
  const s = map[status];

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-6">
      <div className="card-surface rounded-2xl p-10 max-w-sm w-full text-center">
        <div className="flex justify-center">{s.icon}</div>
        <h1 className="font-heading text-4xl mt-5">{s.title}</h1>
        <p className="text-secondary mt-2">{s.sub}</p>
        <button data-testid="billing-continue" onClick={() => navigate("/app")}
          className="w-full mt-7 py-3 bg-brand text-white font-bold uppercase tracking-wide rounded-lg hover:bg-brand-hover transition-all">
          Go to Dashboard
        </button>
      </div>
    </div>
  );
}
